export const formatCurrency = (value: string): string => {
  let numericValue = value.replace(/\D/g, '');
  if (numericValue) {
    const formatted = (parseInt(numericValue) / 100).toFixed(2);
    return formatted.replace('.', ',');
  }
  return '';
};

export const formatDocument = (value: string): string => {
  const numericValue = value.replace(/\D/g, '');
  
  if (numericValue.length <= 11) {
    // CPF format
    if (numericValue.length > 9) {
      return numericValue.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, '$1.$2.$3-$4');
    } else if (numericValue.length > 6) {
      return numericValue.replace(/(\d{3})(\d{3})(\d{0,3})/, '$1.$2.$3');
    } else if (numericValue.length > 3) {
      return numericValue.replace(/(\d{3})(\d{0,3})/, '$1.$2');
    }
  } else {
    // CNPJ format
    return numericValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, '$1.$2.$3/$4-$5');
  }
  
  return numericValue;
};

export const formatPhone = (value: string): string => {
  const numericValue = value.replace(/\D/g, '');
  
  if (numericValue.length > 10) {
    return numericValue.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  } else if (numericValue.length > 6) {
    return numericValue.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
  } else if (numericValue.length > 2) {
    return numericValue.replace(/(\d{2})(\d{0,5})/, '($1) $2');
  }
  
  return numericValue;
};

export const formatZipCode = (value: string): string => {
  const numericValue = value.replace(/\D/g, '');
  if (numericValue.length > 5) {
    return numericValue.replace(/(\d{5})(\d{0,3})/, '$1-$2');
  }
  return numericValue;
};

export const formatCardNumber = (value: string): string => {
  const numericValue = value.replace(/\D/g, '');
  if (numericValue.length > 0) {
    return numericValue.match(new RegExp('.{1,4}', 'g'))?.join(' ') || numericValue;
  }
  return '';
};

export const formatCardExpiry = (value: string): string => {
  const numericValue = value.replace(/\D/g, '');
  if (numericValue.length > 2) {
    return numericValue.substring(0, 2) + '/' + numericValue.substring(2, 4);
  }
  return numericValue;
};

export const getCardBrand = (cardNumber: string): string => {
  const number = cardNumber.replace(/\D/g, '');
  
  if (number.startsWith('4')) return 'visa';
  if (number.startsWith('5')) return 'mastercard';
  if (number.startsWith('3')) return 'amex';
  
  return 'generic';
};